import { colors, Input, FormControl, Select } from '@spaceshipapp/cambridge';
import styled from 'styled-components';
import DatePicker from 'react-datepicker';

export const FormWrapper = styled.form`
  width: 500px;
  margin: 1rem;
  position: relative;
  background: ${colors.surface};
  border-radius: 8px;
  padding: 2rem;
`;

export const Header = styled.div`
  display: flex;
  margin-top: 1rem;
  padding: 1.5rem;
  justify-content: center;
  align-items: center;
  font-size: 1.5rem;
  border-top: 0.2rem solid;
  color: ${colors.subtext};
  font-weight: 500;
`;

export const InputWrapper = styled.div`
  display: flex;
  padding: 0 1rem;
  padding-bottom: 0.5rem;
  justify-content: space-between;
  align-items: center;
`;

export const InputLabel = styled.span`
  font-size: 1.2rem;
  text-align: left;
  width: 40%;
`;

export const Message = styled.div`
  display: relative;
  width: 100%;
  height: 1rem;
  font-size: 1rem;
  margin-bottom: 1rem;
  margin-top: -1rem;
  color: ${colors.highlightPrimary};
`;

export const CouponSelect = styled(Select)`
  font-size: 1rem;
  width: 100%;
`;

export const CouponInput = styled(Input)`
  font-size: 1rem;
  width: 40%;
`;

export const CouponFormControl = styled(FormControl)`
  font-size: 1rem;
  width: 40%;
`;

export const FormDatePicker = styled(DatePicker)`
  display: block;
  box-sizing: border-box;
  width: 100%;
  border: 1px solid ${colors.border};
  padding: 10px 15px;
  margin-bottom: 10px;
  font-size: 1rem;
  transition: box-shadow 350ms ease;
  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px ${colors.brandPrimary};
  }
`;

export const DatePickerWrapper = styled.div`
  font-size: 1rem;
  width: 40%;
`;

export const ContentWrapper = styled.div`
  position: relative;
  overflow-y: scroll;
  height: 23rem;
  padding: 1rem 0;
  margin-bottom: 1rem;
  border: 2px solid ${colors.border};
  box-shadow: rgba(50, 50, 93, 0.25) 0px 30px 60px -12px inset,
    rgba(0, 0, 0, 0.3) 0px 18px 36px -18px inset;
`;
